import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPremiumStudentApp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 17,
	viewBox: "0 0 15 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Subtract",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.4453 1.21641V8.35124C13.4453 8.7469 13.1226 9.06764 12.7245 9.06764H2.6331C2.23501 9.06764 1.91229 8.7469 1.91229 8.35124V1.21641C1.91229 0.820746 2.23501 0.5 2.6331 0.5H12.7245C13.1226 0.5 13.4453 0.820746 13.4453 1.21641ZM14.1661 12.4883C14.5642 12.4883 14.8869 12.809 14.8869 13.2047V15.7837C14.8869 16.1794 14.5642 16.5002 14.1661 16.5002C13.768 16.5002 13.4453 16.1794 13.4453 15.7837V13.2047C13.4453 12.809 13.768 12.4883 14.1661 12.4883ZM13.8094 11.9617C14.4065 11.9617 14.8906 11.4806 14.8906 10.8871C14.8906 10.2936 14.4065 9.8125 13.8094 9.8125H1.55557C0.958428 9.8125 0.474349 10.2936 0.474349 10.8871C0.474349 11.4806 0.958428 11.9617 1.55557 11.9617H13.8094ZM1.18956 12.4883C1.58766 12.4883 1.91038 12.809 1.91038 13.2047V15.7837C1.91038 16.1794 1.58766 16.5002 1.18956 16.5002C0.791469 16.5002 0.46875 16.1794 0.46875 15.7837V13.2047C0.46875 12.809 0.791469 12.4883 1.18956 12.4883Z",
		fill: "#395FE2"
	})
});
export default SvgIconPremiumStudentApp;
